export default __webpack_public_path__ + "static/media/om.ceaaadfb.jpg";